import { render, staticRenderFns } from "./EventEdition.vue?vue&type=template&id=c03e1ae8&"
import script from "./EventEdition.vue?vue&type=script&lang=js&"
export * from "./EventEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports